// Shopify Burst Constants
export const SHOPIFY_BURST_RSVP_THRESHOLD = 0.75;
export const SHOPIFY_BURST_WEEKS_BEFORE_FIRST_AVAILABLE_DATE = 1;
export const CURRENT_SHOPIFY_BURST_INTERACTION_DATA_SCHEMA_VERSION = 2;
export const SHOPIFY_BURST_MIN_RANGE_SIZE = 1;
export const SHOPIFY_BURST_MAX_RANGE_SIZE = 5;
export const GENERATE_ACCESS_BEFORE_START_DATE = 14;
export const SHOPIFY_BURSTING_APP_CHANNEL_ID = 'cafeb170-d42c-4977-96fe-5ceb84c04a4b';

// Shopify RSVP Constants
export const SHOPIFY_BURST_RSVP_VALID_DAYS = 14;

// RSVP UI Text Constants
export const rsvpAttendTitle = `Will you be attending this burst in person?`;
export const rsvpAttendNote = `Note: if you cannot attend in person please click 'No', however remote attendance is still required for bursts. You will be included in all calendar invites as well.`;
export const rsvpChangeNote = 'If you need to change your RSVP, you can always come back and update your submission.';
export const specialRequestTitle = `Add special requests`;
export const specialRequestNote = `Note: Travel will be booked separately once your burst has been confirmed by email.`;
export const specialRequestPlaceholder = `Dietary restrictions? Accessibility requests?`;
export const covidRegulationsTitle = `I understand Shopify's COVID-19 regulations and have uploaded my proof of vaccination to Workday.`;
export const shopifyVaultRsvpLink = 'https://vault.shopify.io/pages/12466-Uploading-Your-Vaccination-Records';
export const covidRegulationsErrorMessage = `Due to Shopify's Covid-19 vaccination policies, you are not able to attend this burst in person. Please change your in-person attendance to 'No' to complete your RSVP.`;
